import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import * as AdministratorActions from './administrator.actions';
import * as sharedAction from '../shared/shared.actions';
import { map, exhaustMap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AdministratorService } from '../../services/administrator/administrator.service';
import { of } from 'rxjs';
import { ADMIN_EOL_CONSUMER, CustomModalService, DELETE_RECORD_LABEL } from '@piqet-angular/shared';
import { AdministratorFacade } from './administrator.facade';
import { LoginLogsGridService } from 'libs/features/src/lib/layout/administrator/user-managment/login-logs/login-logs-data-grid.service';
import { SharedFacade } from '../shared/shared.facade';
import { AdminOrganizatioDataGridService } from 'libs/features/src/lib/layout/administrator/user-managment/admin-organization/admin-organization-data-grid.service';
import { MaterialDataGridServiceService } from 'libs/features/src/lib/layout/administrator/data-management/materials-impact-data/materials/material-data-grid-service.service';
import { conversionDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/conversion/conversion-data-grid.service';
import { IngredientsDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/materials-impact-data/ingredients/ingredients-data-grid.service';
import { RecycledMaterialDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/materials-impact-data/recycled-materials-impact/recycled-material-data-grid.service';
import { areaBasedConversionDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/area-based-conversion/area-based-conversion-data-grid.service';
import { EnergyAndAncillaryDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/energy-and-ancillary/energy-data-grid.service';
import { TransportDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/transport/transport-data-grid.service';
import { StoragetDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/storage/storage-data-grid.service';
import { ProcessingCustomConversionDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/processing-data-custom-conversion/processing-custom-conversion-data-grid.service';
import { ProcessingWasteDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/waste/waste-data-grid.service';
import { RefrigeratedTruckDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/refrigerated-trucks/refrigerated-data-grid.service';
import { ProcessingCustomTruckDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/processing-data/processing-data-custom-trucks/processing-data-custom-truck-data-grid.service';
import { EolDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/eol-data/eol/eol-data-grid.service';
import { OtherMaterialDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/other-data-material-types/other-data-material-data-grid.service';
import { OtherCircularEconomyParameterDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/circular-economy-parameter/circular-economy-parameters-data-grid-service';
import { OtherPalletTypeDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/pallet-type/pallet-type-data-grid.service';
import { OtherProjectStatusDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/project-status/project-status-data-grid.service';
import { OtherScenarioStatusDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/scenario-status/scenario-status-data-grid.service';
import { OtherEquivalancyUnitsDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/equivalancy-units/equivalancy-units-data-grid.service';
import { ConversionMappingDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/eol-data/conversion-mapping/conversion-mapping-data-grid.service';
import { OtherCountryIndetifiersDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/other-data/country-indetifiers/country-identifier-data-grid.service';
import { RecycledContentDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/eol-data/recycled-content/recycled-content-data-grid.service';
import { ProductPackagingRatioDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/eol-data/product-packaging-ratio/product-packaging-ratio-data-grid.service';
import { MiscSimulationDataGridService } from 'libs/features/src/lib/layout/administrator/data-management/misc-simulation/misc-simulation-data-grid.service';
import { CountryDataGridService } from 'libs/features/src/lib/layout/administrator/advanced/country/country-data-grid.service';
import { StateDataGridService } from 'libs/features/src/lib/layout/administrator/advanced/state/state-data-grid.service';
import { CityDataGridService } from 'libs/features/src/lib/layout/administrator/advanced/city/city-data-grid.service';
import { AdminNewsDataGridService } from 'libs/features/src/lib/layout/administrator/advanced/admin-news/admin-news-data-grid.service';
import { AdminRolesDataGridService } from 'libs/features/src/lib/layout/administrator/advanced/admin-roles/admin-roles-data-grid.service';
import { SharedService } from '../../services/shared/shared.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable()
export class AdministratorEffects {
  endPoint: any;
  private actions$ = inject(Actions);

  getAdminOrganizationData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getAdminOrganizationData),
      exhaustMap(action => {
        return this.administratorService
          .GetAdminOrganizatioList(action.adminOrganizationPayload)
          .pipe(
            map((data: any) => {
              return AdministratorActions.getAdminOrganizationDataSuccess({
                adminOrganizationData: data.data,
              });
            }),
            catchError((error: any) =>
              of(AdministratorActions.getAdminOrganizationDataFailure(error))
            )
          );
      })
    )
  );

  deleteOrganizationEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AdministratorActions.deleteOrganization),
        exhaustMap((action: any) => {
          return this.alertConfirmation(action);
        })
      ),
    { dispatch: false }
  );

  //Effects for deleteAdminData.
  deleteOrganizationData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.deleteOrganizationData),
      exhaustMap(action => {
        switch (action.pathName) {
          case 'processing-data-conversion':
          case 'converting-processes':
            return this.administratorService
              .deleteConversionData(action.payload.convertionProcessId, action.payload.regionId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'Project-Status':
            return this.administratorService.deleteProjectStatusData(action.payload.statusId).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              }),
              catchError((error: any) =>
                of(AdministratorActions.deleteOrganizationDataFailure(error))
              )
            );
            break;
          case 'misc-simulation':
            return this.administratorService
              .deleteMiscSimulationData(action.payload.energyProcessId, action.payload.regionId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'scenario-status':
            return this.administratorService
              .deleteScenarioStatusData(action.payload.scenarioStatusId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'pallet-type':
            return this.administratorService.deletePalletTypeData(action.payload.id).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              }),
              catchError((error: any) =>
                of(AdministratorActions.deleteOrganizationDataFailure(error))
              )
            );
            break;
          case 'processing-custom-truck':
            return this.administratorService
              .deleteProcessingCustomTruckData(action.payload.truckId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'refrigareted-truck':
            return this.administratorService.deleteRefrigeratedTruckData(action.payload.id).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              }),
              catchError((error: any) =>
                of(AdministratorActions.deleteOrganizationDataFailure(error))
              )
            );
            break;
          case 'area-based-conversion':
            return this.administratorService
              .deleteAreaBasedConversionData(
                action.payload.conversionProcessId,
                action.payload.regionId
              )
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'Transport':
            return this.administratorService
              .deleteTransportData(action.payload.transportModeId, action.payload.regionId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'processing-custom-conversion':
            return this.administratorService
              .deleteProcessingCustomConversionData(
                action.payload.energyProcessId,
                action.payload.regionId
              )
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'admin-ingredients':
            return this.administratorService
              .deleteAdminIngredientsData(action.payload.ingredientId, action.payload.regionId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'CountryIndetifiers':
            return this.administratorService
              .deleteCountryIndetifiersData(action.payload.id, action.payload.associatedRegionId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'CircularEconomyParameter':
            return this.administratorService
              .deleteCircularEconomyParametersData(action.payload.circularEconomyParameterId)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                }),
                catchError((error: any) =>
                  of(AdministratorActions.deleteOrganizationDataFailure(error))
                )
              );
            break;
          case 'EOL-RC':
            return this.handleDeleteEOL(action, '/EOL_RC/DeleteEndofLifeRC');
          case 'EOL-LF':
            return this.handleDeleteEOL(action, '/EOL_LF/DeleteEndofLifeLF');
          case 'EOL-CC':
            return this.handleDeleteEOL(action, '/EOL_CC/DeleteEndofLifeCC');
          case 'EOL-HC':
            return this.handleDeleteEOL(action, '/EOL_HC/DeleteEndofLifeHC');
          case 'EOL-ER':
            return this.handleDeleteEOL(action, '/EOL_ER/DeleteEndofLifeER');
          case 'EOL-IC':
            return this.handleDeleteEOL(action, '/EOL_IC/DeleteEndofLifeIC');
          case 'EOL-OD':
            return this.handleDeleteEOL(action, '/EOL_OD/DeleteEndofLifeOD');
          case 'EOL-SW':
            return this.handleDeleteEOL(action, '/EOL_SW/DeleteEndofLifeSW');
          case 'EOL-SE':
            return this.handleDeleteEOL(action, '/EOL_SE/DeleteEndofLifeSE');
          case 'EOL-LT':
            return this.handleDeleteEOL(action, '/EOL_LT/DeleteEndofLifeLT');
          case 'EOL-AD':
            return this.handleDeleteEOL(action, '/EOL_AD/DeleteEndofLifeAD');
          case 'EOL-RATES':
            return this.handleDeleteEOL(action, '/EOLRates/DeleteEOLImpactRates');
          case 'EOL-CONSUMERS':
            return this.handleDeleteEOL(action, '/EOLConsumerRates/DeleteEOLImpactConsumerRates');
          case 'EOL-OR':
            return this.handleDeleteEOL(action, '/EOL_OR/DeleteEndofLifeOR');
          case 'EOL-CR':
            return this.handleDeleteEOL(action, '/EOL_CR/DeleteEndofLifeCR');
          case 'EOL-PG':
            return this.handleDeleteEOL(action, '/EOL_PG/DeleteEndofLifePG');
          case 'EOL-OB':
            return this.handleDeleteEOL(action, '/EOL_OB/DeleteEndofLifeOB');
          case 'EOL-NO':
            return this.handleDeleteEOL(action, '/EOL_NO/DeleteEndofLifeNO');
          case 'admin-product-package':
            return this.administratorService
              .deleteProductPackaging(action.payload, action.customType)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                })
              );
            break;
          case 'admin-conversion-mapping':
            return this.administratorService.deleteConversionMapping(action.payload).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              })
            );
            break;
          case 'admin-recycled-content':
            return this.administratorService
              .deleteRecycledContent(action.payload, action.customType)
              .pipe(
                map((data: any) => {
                  data['pathName'] = action.pathName;
                  return AdministratorActions.deleteOrganizationDataSuccess({
                    deleteOrganizationDataMessage: data,
                  });
                })
              );
            break;
          case 'country':
            return this.administratorService.deleteCountry(action.payload).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              })
            );
            break;
          case 'state':
            return this.administratorService.deleteState(action.payload).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              })
            );
            break;
          case 'city':
            return this.administratorService.deleteCity(action.payload).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              })
            );
            break;
          case 'admin-news':
            return this.administratorService.deleteNews(action.payload).pipe(
              map((data: any) => {
                data['pathName'] = action.pathName;
                return AdministratorActions.deleteOrganizationDataSuccess({
                  deleteOrganizationDataMessage: data,
                });
              })
            );
            break;
          default:
            return of();
            break;
        }
      })
    )
  );

  deleteOrganizationDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.deleteOrganizationDataSuccess),
      exhaustMap(action => {
        let toaster: any = action.deleteOrganizationDataMessage.messageType
          ? sharedAction.ToasterError({
              description: action.deleteOrganizationDataMessage.message,
            })
          : sharedAction.ToasterSuccess({
              description: action.deleteOrganizationDataMessage.message,
            });
        switch (action.deleteOrganizationDataMessage.pathName) {
          case 'adminOrganization':
            // eslint-disable-next-line no-case-declarations
            const adminOrganizationPayload = this.adminOrganizationDataGridService.getPayload('');
            return of(
              AdministratorActions.getAdminOrganizationData({
                adminOrganizationPayload: adminOrganizationPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'processing-data-conversion':
          case 'converting-processes':
            // eslint-disable-next-line no-case-declarations
            toaster =
              action.deleteOrganizationDataMessage.pathName == 'converting-processes'
                ? sharedAction.ToasterSuccess({
                    description: 'converting process deleted successfully.',
                  })
                : sharedAction.ToasterSuccess({
                    description: 'Conversion deleted successfully.',
                  });
            const processingConversionPayload = this.conversionDataGridService.getPayload('');
            return of(
              AdministratorActions.getConversionList({
                payload: processingConversionPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'processing-custom-conversion':
            // eslint-disable-next-line no-case-declarations
            const processingCustomConversionPayload =
              this.processingCustomConversionDataGridService.getPayload('');
            return of(
              AdministratorActions.getProcessingCustomConversionList({
                payload: processingCustomConversionPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'pallet-type':
            // eslint-disable-next-line no-case-declarations
            const palletTypePayload = this.otherPalletTypeDataGridService.getPayload('');
            return of(
              AdministratorActions.getOtherDataPalletTypeList({
                payload: palletTypePayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'CountryIndetifiers':
            // eslint-disable-next-line no-case-declarations
            const countryIndetifiersPayload =
              this.otherCountryIndetifiersDataGridService.getPayload('');
            return of(
              AdministratorActions.getOtherDataCountryIndetifiersList({
                payload: countryIndetifiersPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'Project-Status':
            // eslint-disable-next-line no-case-declarations
            const projectStatusPayload = this.otherProjectStatusDataGridService.getPayload('');
            return of(
              AdministratorActions.getOtherDataProjectstatusList({
                payload: projectStatusPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'scenario-status':
            // eslint-disable-next-line no-case-declarations
            const scenarioStatusPayload = this.otherScenarioStatusDataGridService.getPayload('');
            return of(
              AdministratorActions.getOtherDataScenarioStatusList({
                payload: scenarioStatusPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'refrigareted-truck':
            // eslint-disable-next-line no-case-declarations
            const refrigeratedTruckPayload = this.refrigeratedTruckDataGridService.getPayload('');
            return of(
              AdministratorActions.getRefrigeratedTruckList({
                payload: refrigeratedTruckPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'misc-simulation':
            // eslint-disable-next-line no-case-declarations
            const miscSimulationPayload = this.miscSimulationDataGridService.getPayload('');
            return of(
              AdministratorActions.getMiscSimulationList({
                payload: miscSimulationPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'area-based-conversion':
            // eslint-disable-next-line no-case-declarations
            const areaBasedConversionPayload = this.areaBasedConversionGridService.getPayload('');
            return of(
              AdministratorActions.getAreaBasedConversionList({
                payload: areaBasedConversionPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'CircularEconomyParameter':
            // eslint-disable-next-line no-case-declarations
            const circularEconomyParameterayload =
              this.otherCircularEconomyParameterDataGridService.getPayload('');
            return of(
              AdministratorActions.getOtherDataCircularEconomyParameterList({
                payload: circularEconomyParameterayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'EOL-RC':
          case 'EOL-LF':
          case 'EOL-CC':
          case 'EOL-HC':
          case 'EOL-ER':
          case 'EOL-IC':
          case 'EOL-OD':
          case 'EOL-SW':
          case 'EOL-SE':
          case 'EOL-LT':
          case 'EOL-AD':
          case 'EOL-RATES':
          case 'EOL-CONSUMERS':
          case 'EOL-OR':
          case 'EOL-CR':
          case 'EOL-PG':
          case 'EOL-OB':
          case 'EOL-NO':
            const eolRCPayload = this.eolDataGridService.getEolPayload('');
            return of(
              AdministratorActions.getEolList({ eolPayload: eolRCPayload }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'admin-product-package':
            const productPackagePayload = this.productPackagingRatioDataGridService.getPayload('');
            return of(
              AdministratorActions.getProductPackageRatioList({
                payload: productPackagePayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'admin-recycled-content':
            const recycledContentPayload = this.recycledContentDataGridService.getPayload('');
            return of(
              AdministratorActions.getRecycledContentList({
                payload: recycledContentPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'country':
            const countryPayload = this.countryDataGridService.getPayload('');
            return of(
              AdministratorActions.getAdminCountryList({
                payload: countryPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'state':
            const statePayload = this.stateDataGridService.getPayload('');
            return of(
              AdministratorActions.getAdminStateList({ payload: statePayload }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'city':
            const cityPayload = this.stateDataGridService.getPayload('');
            return of(
              AdministratorActions.getAdminCityList({ payload: cityPayload }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'admin-news':
            const newsPayload = this.adminNewsDataGridService.getPayload('');
            return of(
              AdministratorActions.getAdminNewsList({ payload: newsPayload }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          default:
            return of();
            break;
        }
      })
    )
  );

  inlineDataEditForAdminOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.inlineDataEditForAdminOrganization),
      exhaustMap(action => {
        return this.administratorService.adminOrganizationInlineEdit(action.adminOrganization).pipe(
          map((data: any) => {
            return AdministratorActions.inlineDataEditForAdminOrganizationSuccess({
              organizationData: data,
            });
          }),
          catchError((error: any) =>
            of(AdministratorActions.inlineDataEditForAdminOrganizationFailure(error))
          )
        );
      })
    )
  );

  inlineDataEditForAdminOrganizationSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.inlineDataEditForAdminOrganizationSuccess),
      exhaustMap(action => {
        if (action.organizationData.messageType != 0) {
          return of(
            AdministratorActions.inlineDataEditForAdminOrganizationFailure({
              error: action.organizationData.message,
            }),
            sharedAction.ToasterError({
              description: action.organizationData.message,
            })
          );
        } else {
          const toaster = action.organizationData.messageType
            ? sharedAction.ToasterError({
                description: action.organizationData.message,
              })
            : sharedAction.ToasterSuccess({
                description: action.organizationData.message,
              });
          const adminOrganizationPayload = this.adminOrganizationDataGridService.getPayload('');
          return of(
            AdministratorActions.getAdminOrganizationData({
              adminOrganizationPayload: adminOrganizationPayload,
            }),
            toaster,
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addEditProcessingConversion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditProcessingConversion),
      exhaustMap(action => {
        return this.administratorService.addUpdateConversion(action.conversion.payload).pipe(
          map((data: any) => {
            data['pathName'] = action.conversion.pathName;
            data['modalName'] = action.conversion.modalName;
            return AdministratorActions.addEditProcessingConversionSuccess({
              processignConversion: data,
            });
          }),
          catchError((error: any) =>
            of(AdministratorActions.addEditProcessingConversionFailure(error))
          )
        );
      })
    )
  );

  addEditProcessingConversionSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditProcessingConversionSuccess),
      exhaustMap(action => {
        if (action.processignConversion.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.processignConversion.message,
            })
          );
        } else {
          this.modal.close();
          const conversionPayload = this.conversionDataGridService.getPayload('');
          return of(
            AdministratorActions.getConversionList({
              payload: conversionPayload,
            }),
            sharedAction.ToasterSuccess({
              description:
                action.processignConversion.pathName == 'processing-data-conversion' &&
                action.processignConversion.modalName == 'add'
                  ? 'conversion  added succesfully'
                  : action.processignConversion.pathName == 'processing-data-conversion' &&
                    action.processignConversion.modalName == 'edit'
                  ? 'conversion updated succesfully'
                  : action.processignConversion.pathName == 'converting-processes' &&
                    action.processignConversion.modalName == 'add'
                  ? 'converting process added succesfully'
                  : action.processignConversion.pathName == 'converting-processes' &&
                    action.processignConversion.modalName == 'edit'
                  ? 'converting process updated succesfully'
                  : '',
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addEditAdminRecycledSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditAdminRecycledSuccess),
      exhaustMap(action => {
        if (action.adminRecycled.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.adminRecycled.message,
            })
          );
        } else {
          this.modal.close();
          const recycledPayload = this.recycledMaterialDataGridService.getPayload('');
          return of(
            AdministratorActions.getRecycledMaterialList({
              recycledMaterialPayload: recycledPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.adminRecycled.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  getTransportListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getTransportListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  getProcessingCustomConversionListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getProcessingCustomConversionListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  addEditEnergyandAncillarySuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditEnergyandAncillarySuccess),
      exhaustMap(action => {
        if (action.energyAncillaryData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.energyAncillaryData.message,
            })
          );
        } else {
          this.modal.close();
          const energyAncillaryPayload = this.energyAncillaryDataGridService.getPayload('');
          return of(
            AdministratorActions.getEnergyandAncillaryList({
              payload: energyAncillaryPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.energyAncillaryData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );
  addEditTransportSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditTransportSuccess),
      exhaustMap(action => {
        if (action.transportData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.transportData.message,
            })
          );
        } else {
          this.modal.close();
          const transportPayload = this.transportDataGridService.getPayload('');
          return of(
            AdministratorActions.getTransportList({
              payload: transportPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.transportData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addEditProcessingCustomConversionSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditProcessingCustomConversionSuccess),
      exhaustMap(action => {
        if (action.processingCustomConversionData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.processingCustomConversionData.message,
            })
          );
        } else {
          this.modal.close();
          const processingCustomConversionPayload =
            this.processingCustomConversionDataGridService.getPayload('');
          return of(
            AdministratorActions.getProcessingCustomConversionList({
              payload: processingCustomConversionPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.processingCustomConversionData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addEditWaste$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditWaste),
      exhaustMap(action => {
        return this.administratorService.addUpdateWaste(action.waste).pipe(
          map((data: any) => {
            return AdministratorActions.addEditWasteSuccess({
              wasteData: data,
            });
          }),
          catchError((error: any) => of(AdministratorActions.addEditWasteFailure(error)))
        );
      })
    )
  );

  addEditWasteSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditWasteSuccess),
      exhaustMap(action => {
        if (action.wasteData.messageType != 0) {
          return of(sharedAction.ToasterError({ description: action.wasteData.message }));
        } else {
          this.modal.close();
          const wastePayload = this.processingWasteDataGridService.getPayload('');
          return of(
            AdministratorActions.getWasteList({ payload: wastePayload }),
            sharedAction.ToasterSuccess({
              description: action.wasteData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  getEolList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getEolList),
      exhaustMap(action => {
        let urlSlash = this.router.url.lastIndexOf('/');
        let path = this.router.url.slice(urlSlash + 1);
        if (path == 'admin-eol-rates') {
          return this.administratorService.getEOLRatesGridData(action.eolPayload).pipe(
            map((data: any) => {
              return AdministratorActions.getEolListSuccess({
                eolList: data.data,
              });
            }),
            catchError((error: any) => of(AdministratorActions.getEolListFailure(error)))
          );
        } else if (path == ADMIN_EOL_CONSUMER) {
          return this.administratorService.getEOLConsumersGridData(action.eolPayload).pipe(
            map((data: any) => {
              return AdministratorActions.getEolListSuccess({
                eolList: data.data,
              });
            }),
            catchError((error: any) => of(AdministratorActions.getEolListFailure(error)))
          );
        } else {
          return this.administratorService.getEOLGridData(action.eolPayload).pipe(
            map((data: any) => {
              return AdministratorActions.getEolListSuccess({
                eolList: data.data,
              });
            }),
            catchError((error: any) => of(AdministratorActions.getEolListFailure(error)))
          );
        }
      })
    )
  );

  getEolListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getEolListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  addEditEol$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditEol),
      exhaustMap(action => {
        let urlSlash = this.router.url.lastIndexOf('/');
        let path = this.router.url.slice(urlSlash + 1);
        if (path == 'admin-eol-rates') {
          return this.administratorService.addUpdateEolRates(action.eolPayload).pipe(
            map((data: any) => {
              return AdministratorActions.addEditEolSuccess({
                eolData: data,
              });
            }),
            catchError((error: any) => of(AdministratorActions.addEditEolFailure(error)))
          );
        } else if (path == ADMIN_EOL_CONSUMER) {
          return this.administratorService.addUpdateEolConsumer(action.eolPayload).pipe(
            map((data: any) => {
              return AdministratorActions.addEditEolSuccess({
                eolData: data,
              });
            }),
            catchError((error: any) => of(AdministratorActions.addEditEolFailure(error)))
          );
        } else {
          return this.administratorService
            .addUpdateEol(action.eolPayload, action.eolPayload.endPoint)
            .pipe(
              map((data: any) => {
                return AdministratorActions.addEditEolSuccess({
                  eolData: data,
                });
              }),
              catchError((error: any) => of(AdministratorActions.addEditEolFailure(error)))
            );
        }
      })
    )
  );

  addEditProcessingCustomTruckSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditProcessingCustomTruckSuccess),
      exhaustMap(action => {
        if (action.processingCustomTruckData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.processingCustomTruckData.message,
            })
          );
        } else {
          this.modal.close();
          const processingCustomTruckPayloadPayload =
            this.processingCustomTruckDataGridService.getPayload('');
          return of(
            AdministratorActions.getProcessingCustomTruckList({
              payload: processingCustomTruckPayloadPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.processingCustomTruckData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addEditEolSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditEolSuccess),
      exhaustMap(action => {
        if (action.eolData.messageType != 0) {
          return of(sharedAction.ToasterError({ description: action.eolData.message }));
        } else {
          this.modal.close();
          const eolPayload = this.eolDataGridService.getEolPayload('');
          return of(
            AdministratorActions.getEolList({ eolPayload: eolPayload }),
            sharedAction.ToasterSuccess({
              description: action.eolData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  deleteRecycledContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.deleteRecycledContent),
      exhaustMap(action => {
        if (action.successMsg.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.successMsg.message,
            })
          );
        } else {
          const recycledContentPayload = this.recycledContentDataGridService.getPayload('');
          return of(
            AdministratorActions.getRecycledContentList({
              payload: recycledContentPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.successMsg.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  getRecycledContent = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getRecycledContentList),
      exhaustMap(action => {
        return this.administratorService.getRecycledList(action.payload).pipe(
          map((data: any) => {
            return AdministratorActions.getRecycledContentListSuccess({
              recycledContentList: data.data,
            });
          }),
          catchError((error: any) => of(AdministratorActions.getRecycledContentListFailure(error)))
        );
      })
    )
  );

  getRecycledContentSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getRecycledContentListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  addEditRecycledContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditRecycledContent),
      exhaustMap(action => {
        return this.administratorService.addUpdateRecycledContent(action.recycledPayload).pipe(
          map((data: any) => {
            data['pathName'] = action.recycledPayload.pathName;
            return AdministratorActions.addEditRecycledContentSuccess({
              recycledData: data,
            });
          }),
          catchError((error: any) => of(AdministratorActions.addEditRecycledContentFailure(error)))
        );
      })
    )
  );

  addEditRecycledContentSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditRecycledContentSuccess),
      exhaustMap(action => {
        if (action.recycledData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.recycledData.message,
            })
          );
        } else {
          this.modal.close();
          const recycledContentPayload = this.recycledContentDataGridService.getPayload('');
          return of(
            AdministratorActions.getRecycledContentList({
              payload: recycledContentPayload,
            }),
            sharedAction.ToasterSuccess({
              description: action.recycledData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  getProductPackageRatio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getProductPackageRatioList),
      exhaustMap(action => {
        return this.administratorService.getProductPackageRatioList(action.payload).pipe(
          map((data: any) => {
            return AdministratorActions.getProductPackageRatioListSuccess({
              productPackageRatioList: data.data,
            });
          }),
          catchError((error: any) =>
            of(AdministratorActions.getProductPackageRatioListFailure(error))
          )
        );
      })
    )
  );

  getProductPackageRatioSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getProductPackageRatioListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  addEditProductPackageRatio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditProductPackageRatio),
      exhaustMap(action => {
        return this.administratorService
          .addUpdateProductPackageRatio(action.productPackageRatioPayload)
          .pipe(
            map((data: any) => {
              data['pathName'] = action.productPackageRatioPayload.pathName;
              return AdministratorActions.addEditProductPackageRatioSuccess({
                productPackageRatioData: data,
              });
            }),
            catchError((error: any) =>
              of(AdministratorActions.addEditProductPackageRatioFailure(error))
            )
          );
      })
    )
  );

  addEditProductPackageRatioSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.addEditProductPackageRatioSuccess),
      exhaustMap(action => {
        if (action.productPackageRatioData.messageType != 0) {
          return of(
            sharedAction.ToasterError({
              description: action.productPackageRatioData.message,
            })
          );
        } else {
          this.modal.close();
          const productPackageRatioPayload =
            this.productPackagingRatioDataGridService.getPayload('');
          return of(
            AdministratorActions.getProductPackageRatioList({
              payload: productPackageRatioPayload,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true }),
            sharedAction.ToasterSuccess({
              description: action.productPackageRatioData.message,
            })
          );
        }
      })
    )
  );

  getAdminCountrySuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getAdminCountryListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );
  getAdminCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.getAdminCountryList),
      exhaustMap(action => {
        return this.administratorService.getAdminCountryList(action.payload).pipe(
          map((data: any) => {
            return AdministratorActions.getAdminCountryListSuccess({
              countryList: data.data,
            });
          }),
          catchError((error: any) => of(AdministratorActions.getAdminCountryListFailure(error)))
        );
      })
    )
  );

  async alertConfirmation(action: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.administratorFacade.deleteOrganizationData(
          action.action,
          action.pathName,
          action.customType
        );
      }
    });
  }

  invokeModal(data: any, action: any) {
    this.modal.invoke('newOtherMaterial', {
      initialState: {
        newOtherMaterialData: data.data,
        label: action.actionLabel,
        pathName: action.pathName,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.savOtherDataMaterialEvent.subscribe(
      (savOtherDataMaterialEvent: any) => {
        return of(this.administratorFacade.addEditOtherDataMaterial(savOtherDataMaterialEvent));
      }
    );
  }
  private handleDeleteEOL(action: any, endPoint: string) {
    this.endPoint = endPoint;
    return this.administratorService
      .deleteEolData(action.payload, action.customType, this.endPoint)
      .pipe(
        map((data: any) => {
          data['pathName'] = action.pathName;
          return AdministratorActions.deleteOrganizationDataSuccess({
            deleteOrganizationDataMessage: data,
          });
        })
      );
  }

  constructor(
    private administratorService: AdministratorService,
    private miscSimulationDataGridService: MiscSimulationDataGridService,
    private otherCircularEconomyParameterDataGridService: OtherCircularEconomyParameterDataGridService,
    private otherPalletTypeDataGridService: OtherPalletTypeDataGridService,
    private otherProjectStatusDataGridService: OtherProjectStatusDataGridService,
    private otherScenarioStatusDataGridService: OtherScenarioStatusDataGridService,
    private otherEquivalancyUnitsDataGridService: OtherEquivalancyUnitsDataGridService,
    private otherCountryIndetifiersDataGridService: OtherCountryIndetifiersDataGridService,
    private modal: CustomModalService,
    private router: Router,
    private loginLogsDataGridService: LoginLogsGridService,
    private adminOrganizationDataGridService: AdminOrganizatioDataGridService,
    private administratorFacade: AdministratorFacade,
    private sharedFacade: SharedFacade,
    private conversionDataGridService: conversionDataGridService,
    private areaBasedConversionGridService: areaBasedConversionDataGridService,
    private materialDataGridService: MaterialDataGridServiceService,
    private ingredientsDataGridService: IngredientsDataGridService,
    private recycledMaterialDataGridService: RecycledMaterialDataGridService,
    private energyAncillaryDataGridService: EnergyAndAncillaryDataGridService,
    private transportDataGridService: TransportDataGridService,
    private storagetDataGridService: StoragetDataGridService,
    private processingWasteDataGridService: ProcessingWasteDataGridService,
    private refrigeratedTruckDataGridService: RefrigeratedTruckDataGridService,
    private processingCustomConversionDataGridService: ProcessingCustomConversionDataGridService,
    private processingCustomTruckDataGridService: ProcessingCustomTruckDataGridService,
    private eolDataGridService: EolDataGridService,
    private otherMaterialDataGridService: OtherMaterialDataGridService,
    private conversionMappingDataGridService: ConversionMappingDataGridService,
    private recycledContentDataGridService: RecycledContentDataGridService,
    private productPackagingRatioDataGridService: ProductPackagingRatioDataGridService,
    private countryDataGridService: CountryDataGridService,
    private stateDataGridService: StateDataGridService,
    private cityDataGridService: CityDataGridService,
    private adminNewsDataGridService: AdminNewsDataGridService,
    private adminRolesDataGridService: AdminRolesDataGridService,
    private sharedService: SharedService,
    private swalService: SwalService
  ) {}
}
